<template>
  <form @submit.prevent="onRating()">
    <p class="mb-2 font-weight-bold">Deja tu reseña y califica nuestros servicios</p>
    <v-app class="mb-2">
      <v-rating background-color="warning lighten-1" color="warning" length="5" size="45"
        v-model="form.rating"></v-rating>
    </v-app>
    <textarea v-model="form.comment" class="form-control mb-3" placeholder="Escribe tu reseña aquí..."
      rows="4"></textarea>
    <button type="submit" class="btn btn-dark w-100" :disabled="!form.rating">Enviar</button>
  </form>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      result: -1,
      form: {
        rating: 0
      },
      API: process.env.API
    }
  },
  methods: {
    onRating: function () {
      this.result = -2
      setTimeout(() => {
        this.form.name = `${this.data.first_name} ${this.data.last_name}`
        this.form.email = this.data.email
        this.form.phone = this.data.phone
        this.$axios({
          url: '/rating',
          method: 'POST',
          data: this.form
        })
          .then((resp) => {
            this.form = {
              rating: 0
            }
            this.result = 0
            this.$emit('onClear')
            this.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
          })
          .catch((er) => {
            this.result = 0
          })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Rating.vue